export default __webpack_public_path__ + "static/media/tyler.7e4339d8.jpg";